//#region src/services/cwc-window.service.ts
var e = (e, t) => {
	let n = `scrollbars=yes,resizable=yes,status=no,location=no,toolbar=no,menubar=no,width=${Math.min(window.screen.width, 1200)},height=${Math.min(window.screen.height, 800)},left=0,top=0`, r = window.open(e, t, n);
	if (r) return r.focus(), r;
};
function t(e) {
	return e === "cwcId" || e === "apiOrigin" || e === "previewOrigin";
}
var n = (n, r) => {
	let i = document.createElement("form"), a = "cwcwidget";
	i.setAttribute("method", "post"), i.setAttribute("action", n), i.setAttribute("target", a);
	for (let e in r) {
		if (!t(e)) continue;
		let n = r[e];
		if (n == null) continue;
		let a = document.createElement("input");
		a.type = "hidden", a.name = e, a.value = n, i.appendChild(a);
	}
	document.body.appendChild(i);
	let o = e("", a);
	if (!o) {
		document.body.removeChild(i);
		return;
	}
	return i.submit(), document.body.removeChild(i), o;
};
//#endregion
export { n as t };

//# sourceMappingURL=cwc-window.service-DAyN_Bsf.js.map